import{newRequest}from'lib/v2/request.js';// Legacy request with the `v1` hard coded
var prefix='/v1';export default newRequest({prefix:prefix});